import { IImage } from 'app/utilities/imagePath';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import React, { ReactElement } from 'react';
import './SingleCard.scss';

interface SingleCardProps {
    mainText: string;
    subText: string | ReactElement;
    currencyValue: number | null;
    mainButtonText: string;
    secondButtonText: string;
    image: IImage;
    mainTextColor: string | null;
    mainButtonOnClick: (() => void) | null;
    secondButtonOnClick: (() => void) | null;
}

const SingleCard = function init(props: SingleCardProps): React.ReactElement {
    const {
        mainText,
        subText,
        currencyValue,
        mainButtonText,
        secondButtonText,
        image,
        mainTextColor,
        mainButtonOnClick,
        secondButtonOnClick
    } = props;
    return (
        <div className="card single-card">
            <img src={image.src} alt={image.alt} />
            <p className="main-text" style={{ color: `${mainTextColor}` }}>{mainText}</p>
            {subText && <p className="sub-text">{subText}</p>}
            {currencyValue && <p className="currency-value">{rupiahCurrencyFormatter(currencyValue)}</p>}

            {mainButtonOnClick
            && (
                <button
                    className="btn main-btn"
                    type="button"
                    onClick={mainButtonOnClick}
                >
                    {mainButtonText}
                </button>
            )}

            {secondButtonOnClick
            && (
                <button
                    className="btn second-btn"
                    type="button"
                    onClick={secondButtonOnClick}
                >
                    {secondButtonText}
                </button>
            )}
        </div>
    );
};

export default SingleCard;
